module.exports = __webpack_public_path__ + "components/flag/static/square/at-597fc1156f40f3804cc5b878e2d982d1.svg";